<template>
  <div v-if="data !== null">
    <Top />
    <div class="container">
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-md-6">
          <Pagination :numberOfDots="5" :numberOfVisitedDots="4" />
          <div class="margin-top-75"></div>
          <div class="header-wrapper">
            <h1 class="text-primary-fh left-header" v-html="data.screening.cholesteroltimestampheader"></h1>
          </div>
          <p v-html="data.screening.cholesteroltimestamptext"></p>
          <select class="form-control" v-model="year" :disabled="yearUnknown">
            <option :value="0">Ange årtal</option>
            <option v-for="year in years.slice().reverse()" :value="year" v-bind:key="year">{{ year }}</option>
          </select>
        </div>
        <div class="col-sm"></div>
      </div>
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-md-6">
          <div class="clearfix"></div>
          <div class="btn-group-toggle">
            <label
              class="btn btn-primary btn-lg btn-block checkbox-btn"
              :class="yearUnknown ? 'active': false">
              <input
                type="checkbox"
                v-model="yearUnknown"
                v-bind:value="true"
                autocomplete="off">
              Vet ej
            </label>
          </div>
          <div class="clearfix"></div>
          <button
            class="btn btn-primary btn-lg btn-block"
            :disabled="year === 0 && !yearUnknown"
            @click="verifyTimestamp()">
            Nästa
          </button>
          <div class="clearfix"></div>
          <button class="btn btn-outline-dark btn-lg btn-block" @click="$router.go(-1)">&#8592; Tillbaka</button>
        </div>
        <div class="col-sm"></div>
      </div>
    </div>
    <Bottom />
  </div>
</template>

<script>
import Top from '../../src/components/Top'
import Bottom from '../../src/components/Bottom'
import Pagination from '../../src/components/Pagination'
import config from '../../config/index.js'
import axios from '../plugins/axios'
import FieldId from '../plugins/fieldId'
import { request } from '../plugins/datocms'

export default {
  name: 'screeningcoltime',
  components: {
    Top,
    Bottom,
    Pagination
  },
  data () {
    return {
      data: null,
      year: 0,
      cols: null,
      yearUnknown: false
    }
  },
  methods: {
    verifyTimestamp () {
      if (this.cols) {
        let loader = this.$loading.show()
        const fieldId = FieldId()
        var answer = this.cols

        if (this.yearUnknown) {
          answer.sampleyear = 'Okänt'
        } else {
          answer.sampleyear = this.year
        }
        answer.question2 = 'När togs kolesterolprovet?'
        answer.timestamp = new Date().toLocaleString('sv-SE', { timeZone: 'CET' })

        axios.postScreeningAnswer(config.screeningAnswerUri, JSON.stringify(answer), fieldId).then((response) => {
          if (response.status === 200) {
            loader.hide()
            sessionStorage.removeItem('cols')
            this.$router.push('createremittance')
          }
        }, (error) => {
          if (error.response && error.response.status === 401) {
            loader.hide()
            window.location.href = window.location.origin.concat('/error')
          } else {
            loader.hide()
            console.log(error)
          }
        })
      }
    }
  },
  computed: {
    years () {
      const year = new Date().getFullYear()
      return Array.from({length: year - 1900}, (value, index) => 1901 + index)
    }
  },
  beforeMount () {
    if (sessionStorage.getItem('cols')) {
      this.cols = JSON.parse(sessionStorage.getItem('cols'))
    }
  },
  async mounted () {
    this.data = await request({
      query: `
        {
          screening {
            cholesteroltimestampheader
            cholesteroltimestamptext
          }
        }
      `
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container {
  margin-bottom: 10vh;
  min-height: 60vh;
}
.page-item {
  color: transparent !important;
}
.margin-top-55 {
  margin-top: 55px;
}
.header-wrapper {
  display: flex;
}
.left-header {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/ScreeningCholesterolTimestamp.vue